import { Component, Input, ViewChild } from '@angular/core';
import { CommonModule, NgClass } from '@angular/common';
import { environment } from 'src/environments/environment';
import { lastValueFrom, tap } from 'rxjs';
import { CrudService } from '../services/crud.service';
import { Product } from '../models/product.model';
import { CostServiceService } from '../services/cost-service.service';
import { HorizontalMenuService } from '../services/horizontalmenu.service';
import CustomStore from 'devextreme/data/custom_store';
import { DxButtonModule, DxDataGridModule, DxDataGridComponent, DxPopupModule,
  DxLoadPanelModule, DxPopupComponent } from 'devextreme-angular';
import { PromotionProduct } from '../services/promotion-products.service';
import { StorePositions } from '../models/store-positions.model';
import { RebateNames } from '../models/rebate-names.model';
import { NotifyService } from '../services/notify.service';
import notify from 'devextreme/ui/notify';
import { PromotionRebatesComponent } from '../settings/promotion-rebates/promotion-rebates.component';
import { ProductSelectionComponent } from '../product-selection/product-selection.component';
import { Router } from '@angular/router';
import { JoyrideModule } from 'ngx-joyride';
import { OnboardingService } from '../services/onboarding.service';
import { PageHeaderComponent } from 'src/app/shared/page-header/page-header.component';

@Component({
  selector: 'app-promotion-details-v2',
  imports: [CommonModule, DxButtonModule, NgClass, DxDataGridModule,
    DxPopupModule, DxLoadPanelModule, PromotionRebatesComponent, ProductSelectionComponent, JoyrideModule, PageHeaderComponent],
  templateUrl: './promotion-details-v2.component.html',
  styleUrl: './promotion-details-v2.component.css'
})
export class PromotionDetailsV2Component {

  @Input() header: any;
  @ViewChild(DxDataGridComponent, { static: false }) public dataGrid: DxDataGridComponent;
  @ViewChild('productSelection', {static: false}) productSelection: DxPopupComponent;
  @ViewChild(ProductSelectionComponent, {static: false}) productSelectionComponent: ProductSelectionComponent;
  detailsLoading: boolean = false;
  promoType: string = 'Some Promo Type';
  dataSource: CustomStore<PromotionProduct>;
  promotionProducts: PromotionProduct[] = [];
  existingProductIds: number[] = [];
  rebateNames: any[] = [];
  storePositions: StorePositions[] = [];
  rowKey: number;
  rowData: PromotionProduct;
  columns: any[] = [];
  allowEditing: boolean = true;
  disabled: boolean = false;
  showFilterRow: boolean | null | undefined = false;
  parent: string = 'promotion-details'
  currencyFormat = { type: 'currency', precision: 2 };
  private promoDetailsUrl: string = environment.baseApiUrl + 'promotion-details';
  private promoCoreRangeUrl: string = environment.baseApiUrl + 'core-range-details';
  private baseApiUrl: string = environment.baseApiUrl;

  private readonly detailsTourSteps: string[] = [
    'details-add-product', 'details-update-costs', 'details-save'
  ];

  constructor(
        private crudService: CrudService,
        private notifyService: NotifyService,
        private horizontalMenuService: HorizontalMenuService,
        private costService: CostServiceService,
        private router: Router,
        private onboardingService: OnboardingService
  ) {
    this.loadData();
    if(localStorage.getItem('selectedPromo') !== null) {
      this.header = JSON.parse(localStorage.getItem('selectedPromo') || '{}');
      this.loadData();
      let promotionLocked: string = '';
      if(this.header.status_type === 'closed') {
        this.allowEditing = false;
        this.disabled = true;
        promotionLocked = ' - *** Promotion Locked  - View Only Mode***';
      }
      this.promoType = `${this.header.promotion_name} - ${this.header.description} | Details: ${this.header.promotion_start} - ${this.header.promotion_end}${promotionLocked}`;
    }
  }

  loadData() {
   this.detailsLoading = true;
      this.dataSource = new CustomStore<PromotionProduct>({
          key: 'id',
          load: (loadOptions) => lastValueFrom(this.crudService.getData(
            `${this.promoDetailsUrl}?header_id=${this.header.id}&account_code=${this.header.account_code}&sp`, loadOptions))
          .then((result:any) => {
            this.existingProductIds = (result || []).map((p: PromotionProduct) => p.product_id);
            return this.fetchCoreProducts(result, loadOptions);
          }),
          insert: async (values: PromotionProduct) => {
            values = this.setValues(values);
            // Ensure crudService.insertData returns Promise<PromotionProduct>
            const result = await lastValueFrom(this.crudService.insertData(this.promoDetailsUrl, values));
            return result as PromotionProduct; // Cast the result to PromotionProduct
          },
          update: (key, values: PromotionProduct) => {
            return lastValueFrom(
              this.crudService.updateData(this.promoDetailsUrl+'-v2', key, values).pipe(
                tap((result: any) => {
                    this.notifyService.tellUser(result);
                })
              )
            );
          },
          remove: async (key) => {
            await lastValueFrom(this.crudService.deleteData(this.promoDetailsUrl, key).pipe(
              tap((result: any) => {
                this.notifyService.tellUser(result);
              })
            ));
          },
        });
        console.log("datasource promodetails: ", this.dataSource)
      this.crudService.getData(this.baseApiUrl + 'rebates?type=0').toPromise()
        .then((rebateNames: any) => {
          this.rebateNames = rebateNames.data;
          this.addColumn();
        })
        .catch((error: any) => {
          console.log('Error fetching rebate names: ', error);
        });
  }

  async fetchCoreProducts(result:any, loadOptions:any){
    localStorage.setItem('promo-header-id', this.header.id);
          localStorage.setItem('promotionProducts', JSON.stringify(result || []));
          this.promotionProducts = result || [];

          // Prepare load options for core range products
          const newLoadOptions = {
              ...loadOptions,
              start_date: this.header.promotion_start,
              end_date: this.header.promotion_end
          };
          const httpParams = this.crudService.getParams(newLoadOptions);

          return lastValueFrom(this.crudService.getData(`${this.promoCoreRangeUrl}?start_date=${this.header.promotion_start}&end_date=${this.header.promotion_end}&buying_group_id=${this.header.buying_group_id}`, httpParams))
              .then((coreRange:any) => {
                  localStorage.setItem('coreRangeProducts', JSON.stringify(coreRange.data));
                  this.detailsLoading = false;
                  return result; // Return the original promotion details
              });
  }
  setValues(values: PromotionProduct): PromotionProduct
    {
        const userDetails = localStorage.getItem('userDetails');
        const parsedDetails = JSON.parse(userDetails || '{}');
        values.group_id = parsedDetails.data.group_id;
        values.location_id = parsedDetails.data.location_id;
        values.promotion_header_id = this.header.id;
        if('store_position_name' in values) {
          const position = this.storePositions.find((position) => position.position_name === values.store_position_name);
          values.store_position_id = position?.id || null;
          values.store_position_name = position?.position_name || null;
        }
        if('max_rebate_qty' in values) {
          values.max_rebate_qty = values.max_rebate_qty || null;
        }
        return values;
  }
  
  addColumn() {
    this.columns = [];
    this.rebateNames.forEach((rebate: RebateNames) => {
        this.columns.push({
          dataField: rebate.rebate_name,
          dataType: 'number',
          format: {
            type: 'currency',
            precision: 2
          },
          setCellValue: this.makeRebateSetter(rebate.rebate_name)
        });
    });
  }

  toggleFilterRow(): void {
    this.showFilterRow = !this.showFilterRow;
  }

  updateCosts() {
    this.crudService.getData(`${this.baseApiUrl}update-costs?promotion_header_id=${this.header.id}&account_code=${this.header.account_code}`).subscribe((result:any) => {
      if(result.success) {
        this.dataGrid.instance.refresh();
        notify({ message: 'Update complete' }, 'success');
      } else {
        notify({ message: 'Update failed' }, 'error');
      }
    }
    );
  }

  onEditorPreparing(e: any) {
    if(e.parentType === "dataRow")
     e.editorOptions.onFocusIn = function (args: any) {
       args.element.querySelector("input.dx-texteditor-input").select();
     };
  }

  openProductSelection = (e: any) => {
    const excludeIds = this.promotionProducts.map(p => Number(p.product_id));
    this.productSelectionComponent.loadProducts(excludeIds);
    this.productSelection.instance.show();
  }

  saveDetails(): void {
    this.dataGrid.instance.saveEditData();
  }

  startDetailsTour(): void {
    this.onboardingService.start('promotion-details', this.detailsTourSteps);
  }

  closeProductSelection = () => {
    this.productSelection.instance.hide();
  }

  rebatePopupEvent(e: any){
    const nativeEvent = e.event || e;
    if (nativeEvent.stopPropagation) {
      nativeEvent.stopPropagation();
    }
    this.horizontalMenuService.seteditPromotionRebates(true);
  }

  // Each rebate column gets its own setter that closes over its dataField, so the
  // handler always knows which rebate it is writing — no shared global state, no
  // dependence on focus order or batch timing. newData.rebate is LOAD-BEARING: the
  // backend gate is array_key_exists('rebate', request) (PromotionDetailsGroupsController
  // ::update), so it must always be written or per-type propagation is skipped.
  private makeRebateSetter(rebateColumn: string) {
    return (newData: any, value: any, currentRowData: any) => {
      newData[rebateColumn] = value;
      // Recompute the aggregate from the merged view (pending edits in newData win over
      // stored values) so editing several rebate columns in one batch row stays correct.
      let total = 0;
      this.rebateNames.forEach((rebate: RebateNames) => {
        const v = (newData[rebate.rebate_name] !== undefined)
          ? newData[rebate.rebate_name]
          : currentRowData[rebate.rebate_name];
        total += (+v || 0);
      });
      newData.rebate = total;
    };
  }

  setAllowanceTotal(newData: any, value: any, currentRowData: any): void
  {
    const total = (+currentRowData.allowance_group || 0) + (+currentRowData.allowance_promotion || 0) + (+value || 0);
    newData.allowance = value;
    newData.allowance_total = total;
  }

  setAllowance(newData: any, value: any, currentRowData: any): void
  {
    const amount = (+value || 0) - ((+currentRowData.allowance_group || 0) + (+currentRowData.allowance_promotion || 0));
    newData.allowance_total = value;
    newData.allowance = amount;
  }

  calculateNewCost = (row: Product) =>
  {
    return this.costService.calculateNewCost(row);
  }

  calculateAllowanceTotal(row: any) {
    const allowance_total = (+row.allowance_group || 0) + (+row.allowance_promotion || 0) + (+row.allowance || 0);
    return allowance_total;
  }

  returnToPlanning(event: Event): void {
    this.router.navigate(['/promotions']);
  }

}
